<template>
  <div class="aside__line">
    <div
      class="scrollbar"
    >
      <div
        class="scrollbar__line"
        :style="{ transform: `scaleY(${$route.name === 'home' ? scrollHome : scroll})` }"
      />
    </div>
  </div>
</template>

<script>
import { TweenMax, Expo } from 'gsap/TweenMax';

import aion from '@/scripts/aion';
import hades from '@/scripts/hades';

export default {
  name: 'Scrollbar',

  data() {
    return {
      hades,
      scrollHome: 0,
      signal: false,
    };
  },

  computed: {
    scroll() {
      let scroll = 0;
      if (hades.ref !== null) {
        scroll = hades.ref.amount.y / hades.ref.options.boundries.max.y;
      }
      return scroll;
    },
  },

  watch: {
    $route(n) {
      if (n.name === 'home') {
        window.addEventListener('apollo-update', this.currentPosition);
      } else {
        window.removeEventListener('apollo-update', this.currentPosition);
      }
    },
  },

  mounted() {
    setTimeout(() => {
      aion.add(this.hideAside, 'hideAside', true);
    }, 4000);
  },

  methods: {
    currentPosition(event) {
      if (this.$store.state.loaded) {
        const { height, top } = document.querySelector('.slider__viewport').getBoundingClientRect();
        this.scrollHome = Math.min(Math.max((event.detail.y - top) / height, 0), 1);
      }
    },

    hideAside() {
      if (window.innerWidth <= 1024) return;

      const voices = document.querySelector('aside.left .aside__voice .fx');
      const header = document.querySelector('aside.left header');
      const aside = document.querySelector('aside.right');

      const asides = [voices, header, aside];

      if (this.hades.ref.amount.y === 0) return;
      if (this.$store.state.menu) return;

      if (Math.abs(this.hades.ref.amount.y - this.prevScroll) > 5) {
        this.signal = true;
        TweenMax.killTweensOf(asides);

        TweenMax.staggerTo(asides, 0.6, {
          cycle: {
            xPercent: index => (index === 2 ? 10 : -10),
          },
          xPercent: 100,
          autoAlpha: 0,
          ease: Expo.easeOut,
        }, 0);
      } else if (this.signal) {
        this.signal = false;
        TweenMax.to(asides, 0.6, {
          xPercent: 0,
          autoAlpha: 1,
          ease: Expo.easeOut,
        });
      }

      this.prevScroll = this.hades.ref.amount.y;
    },
  },
};
</script>

<style lang="scss" scoped>
.scrollbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &__line {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color-text, 0.3);
    transform-origin: 0 0;
  }
}
</style>
